import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Button from 'on_web/components/shared/Common/Button';

/**
 * Component displaying section title with background image.
 * @param {Component properties} props
 */
export default function ReportsSectionTitleWithBackground(props) {
  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Museo-500',
      fontSize: '18px',
      lineHeight: 1.22,
      color: '#ffffff',
    },
  }));

  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      style={{
        backgroundImage: 'url(' + props.backgroundImage + ')',
        backgroundSize: 'cover',
        minHeight: 86,
        textAlign: 'center',
      }}
      px={'20px'}
      display="flex"
      justifyContent={
        props.showLeftArrow || props.showRightArrow ? 'space-between' : 'center'
      }
      alignItems="center"
    >
      {props.showLeftArrow ? (
        <Button
          startIcon={<ArrowBackIosIcon />}
          variant="text"
          onClick={props.onClickLeft}
          color="inherit"
        ></Button>
      ) : props.replaceLeftArrow ? (
        <div style={{ minWidth: '64px' }} />
      ) : (
        <React.Fragment />
      )}
      <span>
        {props.title && props.shorten === true && props.title.length > 60
          ? props.title.substring(0, 60) + '...'
          : props.title}
      </span>
      {props.showRightArrow ? (
        <Button
          startIcon={<ArrowForwardIosIcon />}
          variant="text"
          onClick={props.onClickRight}
          color="inherit"
        ></Button>
      ) : props.replaceRightArrow ? (
        <div style={{ minWidth: '64px' }} />
      ) : (
        <React.Fragment />
      )}
    </Box>
  );
}

ReportsSectionTitleWithBackground.propTypes = {
  /**
   * Image to be used as background.
   */
  backgroundImage: PropTypes.string.isRequired,

  /**
   * Section title
   */
  title: PropTypes.string.isRequired,
};
